import { apiRequest } from './index';

export const fetchPerformanceRequest = ( id, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/performances/' + id, {}, success, failure);
}

export const fetchPerformancesRequest = ( success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/performances', {}, success, failure);
}

export const createPerformanceRequest = ( data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/performances',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const editPerformanceRequest = ( id, data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/performances/' + id,
        { 
            method: 'PUT',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const deletePerformanceRequest = ( id, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/performances/' + id,
        { method: 'DELETE' },
        success,
        failure
    )
}
